import React, { useCallback, useEffect, useState } from "react";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";
import GlobalCopilotPanel from "components/Copilot/GlobalCopilotPanel";
import { useCopilotShell } from "contexts/CopilotShellContext";
import AdvisorDataGate from "./AdvisorDataGate";
import AdvisorLockPage from "./AdvisorLockPage";
import { orgHasAdvisorDashboards } from "./hasAdvisorDashboards";
import styles from "./style.module.scss";

const COPILOT_STORAGE_KEY = "pivony_copilot_v2";

const readLastNonAdvisorRoute = () => {
  try {
    const raw = localStorage.getItem(COPILOT_STORAGE_KEY);
    if (!raw) return "/console/my-workspace";
    const state = JSON.parse(raw);
    if (state?.lastRoute && state.lastRoute !== "/console/advisor") {
      return state.lastRoute;
    }
  } catch (_) {}
  return "/console/my-workspace";
};

const AdvisorPage = ({ theme = "dark", user }) => {
  const history = useHistory();
  const { setCopilotOpen, cxGptAccessLoading, hasCxGptAccess } = useCopilotShell();
  const [dataGate, setDataGate] = useState({ loading: true, hasData: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const hasData = await orgHasAdvisorDashboards();
        if (!cancelled) {
          setDataGate({ loading: false, hasData });
        }
      } catch (_) {
        if (!cancelled) {
          setDataGate({ loading: false, hasData: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleDockToPanel = useCallback(() => {
    history.push(readLastNonAdvisorRoute());
    setCopilotOpen(true);
  }, [history, setCopilotOpen]);

  const handleClose = useCallback(() => {
    history.push(readLastNonAdvisorRoute());
  }, [history]);

  const showLoading = cxGptAccessLoading || dataGate.loading;

  return (
    <div className={`${styles.advisorPage} ${styles[`advisorPage_${theme}`] || ""}`}>
      {showLoading ? (
        <div className={styles.advisorLoading}>
          <Spin size="large" />
        </div>
      ) : !hasCxGptAccess ? (
        <AdvisorLockPage
          theme={theme}
          userId={user?.uid}
          onActivated={() => window.location.reload()}
        />
      ) : !dataGate.hasData ? (
        <AdvisorDataGate theme={theme} />
      ) : (
        <GlobalCopilotPanel
          variant="page"
          theme={theme}
          onClose={handleClose}
          onDockToPanel={handleDockToPanel}
          accountUser={user}
        />
      )}
    </div>
  );
};

export default AdvisorPage;
